// extracted by mini-css-extract-plugin
export default {"primaryColor":"#0597ff","primaryColorWithAlpha":"rgba(5,151,255,.1019607843)","mainBgColor":"#f4f4f4","secondBgColor":"#fff","secondaryColor":"#323232"};